/* @ngInject */
function CampaignMaterialsController ($rootScope, $scope, $translate, $q, CampaignService, UdsModalService, ModalService, NewAssetService, CampaignActionService) {
  const getImportSvgDialogController = () => $q.when(import('../../../arts/dialogs/import/import-dialog.controller'))
  const getArtSizeDialogController = () => $q.when(import('../../../arts/dialogs/art-size/art-size-dialog.controller'))
  const getAttachInsideTheModuleModalController = () =>
    $q.when(
      import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller')
    )
  const getCreateCampaignDialogController = () => $q.when(import('../../../admin/dialogs/create-campaign/create-campaign-dialog.controller'))
  const getTemplatePropertiesDialogController = () => $q.when(import('../../../arts/dialogs/template-properties/template-properties-dialog.controller'))

  $scope.flags = {
    campaignMaterialActions: false
  }

  $scope.assets = []
  $scope.folders = []
  $scope.navigationHistory = []
  $scope.selectedMaterials = []

  $scope.selectedScheduleDate = null

  const api = {
    getAttachInsideTheModuleModalController,
    getImportSvgDialogController,
    getArtSizeDialogController,
    getCreateCampaignDialogController,
    getTemplatePropertiesDialogController,
    _shouldShowEmptyState,
    _loadCampaignCollections,
    _loadCampaignTemplates,
    _openAttachAssetsDialog,
    _openImportModal,
    _openFormatDialog,
    _openNewCampaignDialog,
    _openTemplatePropertiesDialog
  }

  $scope.headerButton = {
    items: [
      {
        text: $translate.instant('campaignEdit.arts.emptyState.dropdown.dropdownItems.importMaterial'),
        icon: 'upload',
        click: api._openAttachAssetsDialog
      },
      {
        text: $translate.instant('campaignEdit.arts.emptyState.dropdown.dropdownItems.importSvgModel'),
        icon: 'upload',
        click: api._openImportModal
      },
      {
        text: $translate.instant('campaignEdit.arts.emptyState.dropdown.dropdownItems.createBlankTemplate'),
        icon: 'file-plus',
        click: api._openFormatDialog
      },
      {
        text: $translate.instant('campaignEdit.arts.emptyState.dropdown.dropdownItems.createFolder'),
        icon: 'folder-plus',
        click: api._openNewCampaignDialog
      }
    ]
  }

  $scope.emptyState = {
    shouldShowEmptyState: false,
    imgPath: 'campaign-materials-empty-state',
    title: $translate.instant('campaignEdit.arts.emptyState.title'),
    message: $translate.instant('campaignEdit.arts.emptyState.message'),
    dropdown: {
      type: 'primary',
      text: $translate.instant('campaignEdit.arts.emptyState.dropdown.text'),
      icon: 'plus',
      position: 'right',
      dropdownItems: [...$scope.headerButton.items],
      disabled: $scope.campaign.status === 'FINISHED',
      tooltip: {
        text: $translate.instant('campaignErrors.campaignFinished'),
        position: 'bottom',
        disabled: $scope.campaign.status !== 'FINISHED'
      }
    }
  }

  this.getApi = () => api

  activate()

  function activate () {
    api._loadCampaignCollections($scope.campaign.id)
    api._loadCampaignTemplates($scope.campaign.id)
    $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
      $scope.artsCustomizationAccess = !!features[customizableArtsSlug]
    })
  }

  function _openAttachAssetsDialog () {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          location: 'campaigns',
          avoidSuccessOnConfirm: true
        },
        onClose: async (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }

          api._openTemplatePropertiesDialog(assetsToAttach)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  function _openImportModal () {
    api.getImportSvgDialogController().then(({ ImportSvg }) => {
      const addCompanyDialog = UdsModalService.createModal({
        controller: ImportSvg,
        modalName: 'importDialog',
        data: {
          campaign: $scope.campaign,
          location: 'campaigns',
          artCollectionId: $scope.navigationHistory.length ? $scope.navigationHistory[$scope.navigationHistory.length - 1] : null
        }
      })

      addCompanyDialog.open()
    })
  }

  function _openFormatDialog () {
    api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
      const artSizeDialog = UdsModalService.createModal({
        controller: ArtSizeDialogController,
        modalName: 'artSizeDialog',
        data: {
          campaign: $scope.campaign,
          location: 'campaigns',
          artCollectionId: $scope.navigationHistory.length ? $scope.navigationHistory[$scope.navigationHistory.length - 1] : null
        }
      })

      artSizeDialog.open()
    })
  }

  $scope.reloadCollections = () => {
    api._loadCampaignCollections($scope.campaign.id)
  }

  $scope.openCollection = (campaignId, artCollectionId) => {
    api._loadCampaignCollections(campaignId, artCollectionId)
  }

  const deregisterReloadTemplates = $scope.$on('reload-arts-page', function (event, data) {
    api._loadCampaignTemplates(data.campaignId)
  })

  const deregisterShouldShowToolBar = $rootScope.$on('campaign.change-tab-action', (event, tab) => {
    $scope.flags.campaignMaterialActions = true
  })

  const deregisterSelectMaterialFloatingToolBar = $rootScope.$on('campaign.select-material-floating-tool-bar', function (event, info) {
    if ($scope.templates?.rows?.length) {
      for (const template of $scope.templates?.rows) {
        template.selected = false
      }
    }

    $scope.action = info?.action
    $scope.selectedMaterials = info?.materials
    $scope.selectedScheduleDate = CampaignActionService.getSelectedScheduleDate($scope.selectedMaterials, $scope.selectedScheduleDate)
  })

  const deregisterSetScheduleDate = $rootScope.$on('campaign.set-schedule-date', function (event, scheduleDate) {
    $scope.selectedScheduleDate = scheduleDate
  })

  $scope.$on('$destroy', () => {
    deregisterReloadTemplates()
    deregisterShouldShowToolBar()
    deregisterSelectMaterialFloatingToolBar()
    deregisterSetScheduleDate()
  })

  function _loadCampaignCollections (campaignId, idArtCollection = null) {
    if (idArtCollection && (!$scope.navigationHistory.length || idArtCollection !== $scope.navigationHistory[$scope.navigationHistory.length - 1])) {
      $scope.navigationHistory.push(idArtCollection || null)
    }

    CampaignService.getCampaignCollections({ idArtCollection, campaignId })
      .then((collections) => {
        $scope.folders = collections
        api._loadCampaignTemplates(campaignId, idArtCollection)
        api._shouldShowEmptyState()
      })
  }

  function _loadCampaignTemplates (campaignId, idArtCollection = null) {
    CampaignService.getCampaignTemplates({ campaignId, idArtCollection })
      .then((templates) => {
        templates.rows.forEach(template => {
          if (!template.campaignId) {
            template.campaignId = campaignId
          }
        })

        $scope.templates = templates
        api._shouldShowEmptyState()
      })
  }

  $scope.goBackToPreviousCollection = () => {
    if ($scope.navigationHistory.length > 1) {
      $scope.navigationHistory.pop()
      const previousCollectionId = $scope.navigationHistory[$scope.navigationHistory.length - 1]
      api._loadCampaignCollections($scope.campaign.id, previousCollectionId)
      return
    }

    $scope.navigationHistory.pop()
    api._loadCampaignCollections($scope.campaign.id)
  }

  function _shouldShowEmptyState () {
    const templateRowsCount = $scope?.templates?.rows?.length || 0
    const folderRowsCount = $scope?.folders?.rows?.length || 0
    const navigationHistory = $scope?.navigationHistory || []

    $scope.emptyState.shouldShowEmptyState = (templateRowsCount + folderRowsCount === 0) && (navigationHistory.length === 0)
  }

  function _openNewCampaignDialog () {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      ModalService.showModal({
        templateId: 'createCampaign.html',
        templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: CreateCampaignDialogController,
        data: {
          showHightlightOption: true,
          campaign: $scope.campaign,
          location: 'campaigns',
          artCollectionId: $scope.navigationHistory.length ? $scope.navigationHistory[$scope.navigationHistory.length - 1] : null
        }
      }).then(created => {
        if (created) {
          activate()
        }
      })
    })
  }

  function _openTemplatePropertiesDialog (assetsToAttach) {
    const assetsDetailsPromises = assetsToAttach.map((asset) => NewAssetService.getAssetDetails(asset.id, { formatData: 'raw' }))

    Promise.all(assetsDetailsPromises).then((assetsDetails) => {
      const bulkTemplates = assetsToAttach.length > 1
      api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
        const artCollectionId = $scope.navigationHistory.length ? $scope.navigationHistory[$scope.navigationHistory.length - 1] : null
        const templatePropertiesDialog = UdsModalService.createModal({
          controller: TemplatePropertiesDialogController,
          modalName: 'templatePropertiesDialog',
          data: {
            bulkTemplates,
            assets: assetsDetails,
            isCustomizable: false,
            campaign: $scope.campaign,
            location: 'campaigns',
            artCollectionId
          },
          onClose: (data) => {
            if (data.wasPublished) {
              api._loadCampaignCollections($scope.campaign.id, artCollectionId)
            }
          }
        })

        templatePropertiesDialog.open()
      })
    })
  }
}

export { CampaignMaterialsController }
